import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { class: "flex items-center text-black text-lg" };
var _hoisted_2 = { class: "form" };
var _hoisted_3 = { for: "date" };
var _hoisted_4 = { for: "medical" };
var _hoisted_5 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_6 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
var _hoisted_7 = { for: "medical" };
var _hoisted_8 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_9 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
var _hoisted_10 = { for: "medical" };
var _hoisted_11 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_12 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
var _hoisted_13 = { class: "flex justify-between" };
import { onMounted, ref } from "vue";
import { patientStore } from "../../store/patient";
import { storeToRefs } from "pinia";
import 'vue-i18n';
import { Modal, Input } from "flowbite-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'modal_add',
    setup: function (__props, _a) {
        var __expose = _a.expose;
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var errors = ref([]);
        var mandatoryFields = ['visita_motivazione', 'visita_osservazioni', 'visita_conclusioni'];
        var loading = ref(false);
        var alertConfirmMessage = ref(null);
        var modalType = ref("confirm");
        var showConfirm = ref(false);
        var altro = ref(false);
        var row = ref({});
        var errorInvalidDate = ref('');
        onMounted(function () {
        });
        var resolvePromise;
        function openModal(message, alertModal, newRow) {
            row.value = newRow;
            alertConfirmMessage.value = message;
            alertModal ? (modalType.value = "alert") : (modalType.value = "confirm");
            showConfirm.value = true;
            return new Promise(function (resolve) {
                resolvePromise = resolve;
            });
        }
        function handleUserInput(value) {
            if (value) {
                if (!validateFields()) {
                    return false;
                }
            }
            if (!resolvePromise)
                return;
            resolvePromise(value);
            showConfirm.value = false;
        }
        /*
        function validateDate() {
          const selectedDate = new Date(row.value.visita_data);
          const today = new Date();
        
          if (selectedDate > today) {
            errorInvalidDate.value =  'La data di inserimento non può essere successiva alla data odierna';
             row.value.visita_data = today;
          }else {
            errorInvalidDate.value = '';
          }
        }
        */
        function validateFields() {
            var hasError = false;
            errors.value = [];
            console.log(mandatoryFields);
            mandatoryFields.forEach(function (field, index) {
                var value = null;
                if (typeof field != 'string') {
                    value = row.value[field[0]][field[1]];
                }
                else {
                    value = row.value[field];
                }
                console.log(value);
                if (!value) {
                    console.log(field);
                    console.log(errors);
                    hasError = true;
                    errors.value.push("Questo campo è obbligatorio!");
                }
                else {
                    errors.value.push("");
                }
            });
            if (hasError) {
                return false;
            }
            return true;
        }
        __expose({ openModal: openModal });
        return function (_ctx, _cache) {
            return (showConfirm.value)
                ? (_openBlock(), _createBlock(_unref(Modal), {
                    key: 0,
                    size: "2xl",
                    onClose: _cache[6] || (_cache[6] = function ($event) { return (handleUserInput(false)); })
                }, {
                    header: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Aggiungi nuova visita')), 1)
                    ]; }),
                    body: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("Data rilievo")), 1),
                            _withDirectives(_createElementVNode("input", {
                                id: "dataVisita",
                                type: "date",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((_unref(row).visita_data) = $event); }),
                                class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                            }, null, 512), [
                                [_vModelText, _unref(row).visita_data]
                            ]),
                            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("Motivo visita: *")), 1),
                            _createVNode(_unref(Input), {
                                id: "motivoVisita",
                                class: "mb-2",
                                placeholder: _ctx.$t('Inserisci la motivazione'),
                                modelValue: _unref(row).visita_motivazione,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((_unref(row).visita_motivazione) = $event); })
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("p", _hoisted_5, _toDisplayString(errors.value[0]), 1),
                            _hoisted_6,
                            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("Osservazioni: *")), 1),
                            _createVNode(_unref(Input), {
                                id: "osservaVisita",
                                class: "mb-2",
                                placeholder: _ctx.$t('Inserisci le osservazioni'),
                                modelValue: _unref(row).visita_osservazioni,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((_unref(row).visita_osservazioni) = $event); })
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("p", _hoisted_8, _toDisplayString(errors.value[1]), 1),
                            _hoisted_9,
                            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("Conclusioni: *")), 1),
                            _createVNode(_unref(Input), {
                                id: "concluVisita",
                                class: "mb-2",
                                placeholder: _ctx.$t('Inserisci le conclusioni'),
                                modelValue: _unref(row).visita_conclusioni,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((_unref(row).visita_conclusioni) = $event); })
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("p", _hoisted_11, _toDisplayString(errors.value[2]), 1),
                            _hoisted_12
                        ])
                    ]; }),
                    footer: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("button", {
                                id: "denyBtn",
                                onClick: _cache[4] || (_cache[4] = function ($event) { return (handleUserInput(false)); }),
                                type: "button",
                                class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                            }, _toDisplayString(_ctx.$t("Annulla")), 1),
                            _createElementVNode("button", {
                                id: "submitBtn",
                                onClick: _cache[5] || (_cache[5] = function ($event) { return (handleUserInput(true)); }),
                                type: "button",
                                class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            }, _toDisplayString(_ctx.$t("Salva")), 1)
                        ])
                    ]; }),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
